import React from 'react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  title: 'Mentoría grupal semanal en vivo',
  description: 'Acompañamiento real para que no te quedes trabado solo.',
  image: 'https://cdn.magicpatterns.com/uploads/pto8vpJ6EXXBLHJvBJhTgd/2.png'
}, {
  title: 'Prompts de IA para contenido y anuncios',
  description: 'Para acelerar ideas, copies, hooks y ejecución.',
  image: 'https://cdn.magicpatterns.com/uploads/qHDvJ3X6gDMohYzTYVBCaV/3.png'
}, {
  title: 'Checklist completa de lanzamiento',
  description: 'Para que no se te escape ningún paso importante.',
  image: 'https://cdn.magicpatterns.com/uploads/sU2RFA9BDfGrQiztLsokih/4.png'
}, {
  title: 'Estructura base de landing',
  description: 'Para que puedas armar una página simple y funcional para vender.',
  image: 'https://cdn.magicpatterns.com/uploads/kaALFRogrzn456kjN4NTaF/5.png'
}, {
  title: 'Plantillas de copy para ventas',
  description: 'Para comunicar mejor tu oferta y vender con más claridad.',
  image: 'https://cdn.magicpatterns.com/uploads/1iEEZHJNyrF7h83NFEwcK2/6.png'
}];
export function BonusesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-yellow-50 to-white py-16 md:py-24 px-4" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <div className="inline-block bg-yellow-400 text-gray-900 px-8 py-3 rounded-full font-black text-xl mb-6" data-id="element-64">
            🎁 BONOS INCLUIDOS HOY
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900" data-id="element-65">
            5 Bonos Exclusivos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-66">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer hover:scale-105 transition-transform duration-300 border-4 border-green-500" onClick={scrollToCompra} data-id="element-67">
              <div className="flex justify-center -mb-3 relative z-10 pt-4" data-id="element-68">
                <div className="bg-red-600 text-white px-5 py-2 rounded-full font-black text-sm tracking-wide shadow-lg animate-bounce" data-id="element-69">
                  🎁 GRATIS POR HOY
                </div>
              </div>
              <div className="px-4" data-id="element-70">
                <img src={bonus.image} alt={bonus.title} className="w-full aspect-square object-cover rounded-lg" data-id="element-71" />
              </div>
              <div className="p-6" data-id="element-72">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-73">
                  Bono {index + 1} — {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-74">{bonus.description}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-75">
          <CTAButton text="QUIERO EMPEZAR AHORA" onClick={scrollToCompra} size="large" className="animate-pulse-green" data-id="element-76" />
        </div>
      </div>
    </section>;
}